import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const SkeletonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.marginBottom || '12px'};
`;

const SkeletonLine = styled(SkeletonBase)`
  height: ${(props) => props.height || '16px'};
  width: ${(props) => props.width || '100%'};
`;

const SkeletonHeader = styled(SkeletonBase)`
  height: 28px;
  width: 200px;
  margin-bottom: 24px;
`;

const OrdersListSkeleton = () => {
  return (
    <div>
      <SkeletonHeader />

      {[1, 2, 3, 4].map((i) => (
        <SkeletonCard key={i}>
          <SkeletonRow>
            <SkeletonLine width="120px" height="20px" />
            <SkeletonLine width="80px" height="20px" />
          </SkeletonRow>
          <SkeletonRow marginBottom="8px">
            <SkeletonLine width="150px" height="14px" />
          </SkeletonRow>
          <SkeletonRow marginBottom="0">
            <SkeletonLine width="100px" height="14px" />
            <SkeletonLine width="60px" height="24px" />
          </SkeletonRow>
        </SkeletonCard>
      ))}
    </div>
  );
};

export default OrdersListSkeleton;
